import { Divider } from "@mui/material";
import CheckboxTree, { CheckboxTreeStore } from "designSystem/components/checkbox/CheckboxTree";
import RadioGroup from "designSystem/components/radio/RadioGroup";
import { GridColumn, SearchPlaceholder, SearchTextField, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { actionResource } from "./RestoreFromShapeService";
import { useRestoreFromShapeStore } from "./RestoreFromShapeStore";

export const RestoreSettingsForm: FunctionComponent = observer(() => {
	const store = useRestoreFromShapeStore();
	const {
		filteredAddDSLines,
		filteredDeleteDSLines,
		onChangeRestoreSettings,
		onChangeSearchTextField,
		restoreAllDSLines,
		restoreSettings,
		searchText,
		shouldDisplayAddSection,
		shouldDisplayDeleteSection,
		shouldDisplayUpdateSection,
		subtypeAllLocked,
		filteredUpdateDSLines,
	} = store;

	return (
		<GridColumn scroll spacing={4}>
			<Text res={actionResource("ConfigureRestoreSettings")} />
			<Text res={actionResource("RestoreSettings")} variant="h6" />
			<RadioGroup
				onChange={onChangeRestoreSettings}
				options={restoreSettings}
				value={restoreAllDSLines}
			/>
			<Divider />
			{!subtypeAllLocked && (
				<SearchTextField
					fullWidth
					onChange={onChangeSearchTextField}
					placeholderRes="Search"
					value={searchText}
				/>
			)}
			{shouldDisplayDeleteSection && (
				<CheckboxTree
					branchSpacing={2}
					defaultExpanded={[filteredDeleteDSLines.uniqueId]}
					displayCounts
					store={new CheckboxTreeStore([filteredDeleteDSLines])}
				/>
			)}
			{shouldDisplayUpdateSection && (
				<CheckboxTree
					branchSpacing={2}
					defaultExpanded={[filteredUpdateDSLines.uniqueId]}
					disabled={subtypeAllLocked}
					displayCounts
					store={new CheckboxTreeStore([filteredUpdateDSLines])}
				/>
			)}
			{shouldDisplayAddSection && (
				<CheckboxTree
					branchSpacing={2}
					defaultExpanded={[filteredAddDSLines.uniqueId]}
					disabled={subtypeAllLocked}
					displayCounts
					store={new CheckboxTreeStore([filteredAddDSLines])}
				/>
			)}
			{!shouldDisplayDeleteSection && !shouldDisplayUpdateSection && !shouldDisplayAddSection && (
				<SearchPlaceholder 
					titleProps={{ res: "SEARCH_NO_RESULTS" }}
				/>
			)}
		</GridColumn>
	);
});

export default RestoreSettingsForm;
